import React, { useState } from "react";
import Heroicon from "../Heroicon";

function PodcastLocked({ feed, readFeed, updatePodcast }) {
  const [isLoading, setIsLoading] = useState(false);

  async function retry() {
    setIsLoading(true);
    const result = await readFeed(feed);
    if (!result.locked) {
      updatePodcast(result);
    }
    setIsLoading(false);
  }

  return (
    <>
      <h1 className="mt-6 md:mt-0 text-gray-800 text-2xl md:text-3xl md:text-center">
        Verify Podcast Ownership
      </h1>
      <div className="bg-white mt-6 rounded-lg shadow mb-20">
        <section className="flex gap-4 items-center p-5 md:p-7">
          <Heroicon
            icon="o-lock-closed"
            style="text-red-600 w-20 h-20 p-4 rounded-full bg-red-100"
          />
          <div>
            <h2 className="font-sans text-gray-700 font-bold text-2xl">
              Locked
            </h2>
            <p className="text-gray-500 text-sm mt-1">
              This podcast's RSS feed is locked from being imported.
            </p>
          </div>
        </section>
        <p className="p-5 md:p-7 bg-gray-100 text-gray-600 border-t border-b border-gray-300">
          You'll need to unlock your RSS feed before we can import your Podcast.
          This is done on your previous host's side, and once you're done, you
          can retry the import from here.
        </p>
        <section className="p-5 md:p-7 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <p className="text-gray-500 text-sm">Done unlocking your feed?</p>
            <button
              className="btn-solid btn-primary--light text-sm flex items-center gap-2"
              onClick={retry}
            >
              Retry
              <Heroicon
                icon="o-arrow-path"
                style={`w-5 h-5 ${isLoading && "animate-spin"}`}
              />
            </button>
          </div>
          <a
            href="https://support.castos.com/article/432-my-podcast-is-locked-what-do-i-do"
            target="_blank"
            className="px-4 py-2 flex items-center gap-2 border border-gray-400 rounded-md text-sm text-gray-600 hover:bg-gray-100"
          >
            How to unlock
            <Heroicon icon="o-arrow-up-right" style="w-4 h-4" />
          </a>
        </section>
      </div>
    </>
  );
}

export default PodcastLocked;
